<div class="image-load-div" [ngStyle]="{ position: 'relative' }">
    @if (isError()) {
        <img alt="{{ alt() }}" class="ngoptimizedimage" [src]="src()" [style]="styles()" />
    } @else {
        <img
            alt="{{ alt() }}"
            class="ngoptimizedimage"
            placeholder
            fill
            [ngSrc]="src()"
            [style]="styles()"
            [priority]="priority()"
            (load)="onImageLoad($event)"
            (error)="onImageLoadError($event)" />
    }
</div>
